// extracted by mini-css-extract-plugin
export default {"advertCard":"c-a_in","advertCardNum":"c-a_io"};